import { amplitudeSetContact } from 'common/amplitude';
import { ContactContext, withAuth } from 'common/hoc';
import { useSgTermsAcceptance } from 'common/hooks/useSgTermsAcceptance';
import { IWindow } from 'common/interfaces';
import { MinimalHeader } from 'components/Header/MinimalHeader';
import { PrivateHeader } from 'components/Header/PrivateHeader';
import { PublicHeader } from 'components/Header/PublicHeader';
import { FC, useContext, useEffect } from 'react';

const winInterface = window as IWindow;

const HeaderComponent: FC = () => {
  const contact = useContext(ContactContext);
  const { needsSgTermsAcceptance } = useSgTermsAcceptance();

  // helphero
  useEffect(() => {
    if (!contact) {
      return;
    }

    amplitudeSetContact(contact);

    if (!winInterface.HelpHero) {
      console.error("Can't find and init helphero");

      return;
    }

    winInterface.HelpHero.identify(contact.provider.id, {
      id: contact.id,
      name: `${contact.firstName} ${contact.lastName}`,
      email: contact.email,
      providerId: contact.provider.id,
      providerState: contact.provider.state,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contact]);

  // getsitecontrol
  useEffect(() => {
    if (!contact) {
      return;
    }

    const getSiteParams = {
      id: contact.id,
      name: `${contact.firstName} ${contact.lastName}`,
      email: contact.email,
      providerId: contact.provider.id,
      providerState: contact.provider.state,
      providerCountry: contact.provider.billingAddress?.country,
      providerEmail: contact.provider.email,
    };

    if (!winInterface.gsc) {
      console.error("Can't find and init gsc");

      return;
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    winInterface.gsc('params', getSiteParams);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contact]);

  if (needsSgTermsAcceptance) {
    return <MinimalHeader />;
  }

  return contact ? <PrivateHeader contact={contact} /> : <PublicHeader />;
};

export const Header = withAuth(HeaderComponent);
